import { render, staticRenderFns } from "./reason.vue?vue&type=template&id=7f2c9a42&"
import script from "./reason.vue?vue&type=script&lang=js&"
export * from "./reason.vue?vue&type=script&lang=js&"
import style0 from "./reason.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports